new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#393B46', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#393B46', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#393B46', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();

    var selectOrdenar = document.querySelector('.selectskin')
    if (selectOrdenar) {
        var primeiroOption = selectOrdenar.querySelector('option:first-child')
        if (primeiroOption && primeiroOption.textContent.includes("Ordenar por")) {
            primeiroOption.textContent = primeiroOption.textContent.replace("Ordenar por", "Ordenar")
        }

        if (window.jQuery && jQuery.fn.SelectSkin) {
          jQuery(selectOrdenar).SelectSkin()
        }

        var selectSkin = selectOrdenar.closest('.select-skin')
        var selectMask = selectSkin && selectSkin.querySelector('.select-skin-mask')

        if (selectSkin && selectMask && !selectSkin.querySelector('.select-skin-options')) {
          var selectText = selectMask.querySelector('.select-skin-text')
          var optionsList = document.createElement('ul')

          selectSkin.classList.add('select-skin--orderby')
          selectMask.setAttribute('role', 'button')
          selectMask.setAttribute('tabindex', '0')
          selectMask.setAttribute('aria-haspopup', 'listbox')
          selectMask.setAttribute('aria-expanded', 'false')
          optionsList.className = 'select-skin-options'
          optionsList.setAttribute('role', 'listbox')

          function closeOptions() {
            selectSkin.classList.remove('is-open')
            selectMask.setAttribute('aria-expanded', 'false')
          }

          function toggleOptions() {
            var willOpen = !selectSkin.classList.contains('is-open')
            selectSkin.classList.toggle('is-open', willOpen)
            selectMask.setAttribute('aria-expanded', String(willOpen))

            if (willOpen) {
              var selectedButton = optionsList.querySelector('[aria-selected="true"]')
              if (selectedButton) selectedButton.focus()
            }
          }

          function updateSelectedOption() {
            var selectedOption = selectOrdenar.options[selectOrdenar.selectedIndex]
            if (!selectedOption) return

            if (selectText) selectText.textContent = selectedOption.textContent

            optionsList.querySelectorAll('.select-skin-option').forEach(function(optionButton) {
              optionButton.setAttribute('aria-selected', String(optionButton.dataset.value === selectOrdenar.value))
            })
          }

          Array.prototype.forEach.call(selectOrdenar.options, function(option) {
            var item = document.createElement('li')
            var optionButton = document.createElement('button')

            optionButton.type = 'button'
            optionButton.className = 'select-skin-option'
            optionButton.dataset.value = option.value
            optionButton.textContent = option.textContent
            optionButton.setAttribute('role', 'option')
            optionButton.setAttribute('aria-selected', String(option.selected))

            optionButton.addEventListener('click', function() {
              selectOrdenar.value = option.value
              updateSelectedOption()
              closeOptions()
              selectOrdenar.dispatchEvent(new Event('change', { bubbles: true }))
            })

            item.appendChild(optionButton)
            optionsList.appendChild(item)
          })

          selectMask.addEventListener('click', toggleOptions)
          selectMask.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
              event.preventDefault()
              toggleOptions()
            }
          })

          optionsList.addEventListener('keydown', function(event) {
            var buttons = Array.prototype.slice.call(optionsList.querySelectorAll('.select-skin-option'))
            var currentIndex = buttons.indexOf(document.activeElement)

            if (event.key === 'Escape') {
              closeOptions()
              selectMask.focus()
            } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault()
              var direction = event.key === 'ArrowDown' ? 1 : -1
              var nextIndex = (currentIndex + direction + buttons.length) % buttons.length
              buttons[nextIndex].focus()
            }
          })

          document.addEventListener('click', function(event) {
            if (!selectSkin.contains(event.target)) closeOptions()
          })

          selectOrdenar.addEventListener('change', updateSelectedOption)
          selectSkin.appendChild(optionsList)
          updateSelectedOption()
        }
    }

    const filterSize = document.querySelector(".product-list__filters .product-filter--filters .product-filter__item--size");
    const elementDest = document.querySelector("#buy-sizes");
    if (filterSize && elementDest) {
        const cloneFilterSize = filterSize.cloneNode(true);
        elementDest.append(cloneFilterSize);
    } else if (elementDest) {
        elementDest.style.display = 'none';
    }

    // Implementação do acordeão para filtros
    const filterItems = document.querySelectorAll('.product-filter__item__title');
    filterItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const parent = this.closest('.product-filter__item');
        const submenu = parent.querySelector('.product-filter__sub-menu');

        // Toggle active class no item
        parent.classList.toggle('active');

        // Slide toggle no submenu
        if (parent.classList.contains('active')) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
          submenu.style.maxHeight = '0';
        }
      });
    });

    // Abrir o primeiro filtro por padrão
    const firstFilterItem = document.querySelector('.product-filter__item');
    if (firstFilterItem) {
      firstFilterItem.classList.add('active');
      const firstSubmenu = firstFilterItem.querySelector('.product-filter__sub-menu');
      if (firstSubmenu) {
        firstSubmenu.style.maxHeight = firstSubmenu.scrollHeight + 'px';
      }
    }
  },
});
